
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./settings.cjs.production.min.js')
} else {
  module.exports = require('./settings.cjs.development.js')
}
